import React, { FC, ReactNode } from 'react';
import { Tooltip } from '@material-ui/core';
import { BrandCustomFilter } from 'src/types/filter';

/**
 * A reusable component that disables click functionality and shows a tooltip
 * when selectedCustomFilterTemp is not empty.
 *
 * @param selectedCustomFilterTemp - The currently selected custom filter
 * @param children - The content to be wrapped
 */

interface DisabledWhenCustomFilterProps {
  selectedCustomFilterTemp: BrandCustomFilter | null;
  children: ReactNode;
}

const DisabledWhenCustomFilter: FC<DisabledWhenCustomFilterProps> = ({
  selectedCustomFilterTemp,
  children,
}) => {
  const isDisabled = !!selectedCustomFilterTemp;
  const tooltipTitle = isDisabled
    ? 'Remove brand standard filter to edit these filter panel'
    : '';

  const handleClick = (e: React.MouseEvent) => {
    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  return (
    <Tooltip title={tooltipTitle} disableHoverListener={!isDisabled}>
      <div
        onClick={handleClick}
        onMouseDown={isDisabled ? (e) => e.preventDefault() : undefined}
        style={{
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          opacity: isDisabled ? 0.6 : 1,
          // Allow pointer events for tooltip but block clicks
          pointerEvents: isDisabled ? 'auto' : 'auto',
        }}
      >
        <div
          style={{
            pointerEvents: isDisabled ? 'none' : 'auto',
          }}
        >
          {children}
        </div>
      </div>
    </Tooltip>
  );
};

export default DisabledWhenCustomFilter;
